import api from './api';

export interface NotificationData {
  _id: string;
  userId: string;
  type: string;
  message: string;
  data?: any;
  isRead: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface NotificationResponse {
  data: NotificationData[];
  total: number;
  page: number;
  totalPages: number;
}

export interface NotificationQueryParams {
  page?: number;
  limit?: number;
  isRead?: boolean;
}

class NotificationService {
  async getNotifications(params?: NotificationQueryParams): Promise<NotificationResponse> {
    console.log('Fetching notifications with params:', params);
    const response = await api.get('/notifications', { params });
    console.log('Notifications API response:', response.data);
    return response.data;
  }

  async markAsRead(notificationId: string): Promise<NotificationData> {
    const response = await api.put(`/notifications/${notificationId}/read`);
    return response.data;
  }

  async markAllAsRead(): Promise<{ message: string; count: number }> {
    const response = await api.put('/notifications/mark-all-read');
    return response.data;
  }

  async deleteNotification(notificationId: string): Promise<void> {
    await api.delete(`/notifications/${notificationId}`);
  }

  // Request browser notification permission
  async requestNotificationPermission(): Promise<NotificationPermission> {
    if (!('Notification' in window)) {
      console.warn('This browser does not support desktop notifications');
      return 'denied';
    }

    if (Notification.permission === 'granted') {
      return 'granted';
    }

    if (Notification.permission !== 'denied') {
      const permission = await Notification.requestPermission();
      return permission;
    }

    return Notification.permission;
  }

  // Show browser desktop notification
  showDesktopNotification(title: string, options?: NotificationOptions): void {
    if (!('Notification' in window)) {
      console.warn('This browser does not support desktop notifications');
      return;
    }

    if (Notification.permission === 'granted') {
      new Notification(title, options);
    }
  }
}

export default new NotificationService();
